import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b9ce50d2"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b9ce50d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports